import { DateTime } from 'luxon'
import { Feed, GroupInfo } from '~/models'
import { Media } from './Media'
import { Model } from './Model'
import { datetime } from './serialization'

export class Post extends Model {

  public feed!:   Feed
  public author!: PostAuthor
  public root!:   string | null

  public title!: string | null
  public body!:  string | null
  public media!: Media[]

  public get summary() {
    return truncateSummary(this.firstLine)
  }

  /** The summary without any markup (e.g. `**bold**`), for places that show plain text like breadcrumbs. */
  public get plainSummary() {
    if (this.firstLine == null) { return null }
    return truncateSummary(stripMarkup(this.firstLine))
  }

  private get firstLine() {
    if (this.body == null) { return null }

    // All text before an optional first linebreak
    const match = this.body.match(/(.*)/)
    return match?.[1] ?? null
  }

  @datetime()
  public publishedAt!: DateTime | null

  @datetime()
  public approvedAt!: DateTime | null

  @datetime()
  public redactedAt!: DateTime | null

  public edited!: boolean

  public commentCount!: number
  public reactions!: Record<string, number>
  public myReaction!: string | null

}

export interface PostAuthor {
  type:           'user' | 'participant'
  id:             string
  name:           string
  firstName:      string
  photoURL:       string | null
  identityGroups: Record<string, GroupInfo[]>
}

function truncateSummary(summary: string | null) {
  if (summary == null) { return null }
  if (summary.length <= 50) {
    return summary
  } else {
    return `${summary.substring(0, 50)}...`
  }
}

function stripMarkup(text: string) {
  // Repeat to also unwrap nested markup, like `***bold** italic*`.
  let prev: string
  do {
    prev = text
    text = text
      .replace(/(\*{1,3})(\S(?:.*?\S)?)\1/g, '$2')
      .replace(/(^|\W)_(\S(?:.*?\S)?)_(?=\W|$)/g, '$1$2')
  } while (text !== prev)
  return text
}
